export async function saveCampaignFlow({
    actions,
    payload,
    bonusPrefix = "",
    genBonusIdV2,
    players = [],
    onStage = () => {},
}) {
    if (Array.isArray(payload)) {
        payload = payload[0];
    }
    const nextFrame = () => new Promise(requestAnimationFrame);
    onStage("creating");
    await nextFrame();
    const res = await actions.createCampaignDoc(payload);
    const campaignId =
        res?.data?.campaigns?.[0]?.campaignId ??
        res?.data?.campaignId ??
        null;
    if (!campaignId) {
        throw new Error("No campaignId returned");
    }
    onStage("created", { campaignId });
    if (!players.length) {
        onStage("done");
        return { campaignId };
    }
    onStage("processingPlayers");
    await nextFrame();
    const result = await addPlayersSequentialV2({
        campaignId,
        players,
        actions,
        genBonus: () => genBonusIdV2(bonusPrefix || "", 12),
        onStage
    });
    onStage("done", {
    campaignId,
});

return {
    campaignId,
};

}

// ----------------ADDPLAYER----
export async function addPlayersSequentialV2({
    campaignId,
    players = [],
    actions,
    genBonus,
    onStage = () => {}
}) {

    const nextFrame = () => new Promise(requestAnimationFrame);

    const normalizedPlayers = players.map(p => ({
        playerId: String(p.playerId ?? p.id ?? p.username),
        baseBonusCode: p.baseBonusCode ? p.baseBonusCode : genBonus()
    }));

    onStage("addingPlayers");
    try {
        await actions.addPlayer(campaignId, normalizedPlayers);
    } catch (e) {
        console.error("ADD V2 ERROR", e);
        onStage("done");
        return {
            campaignId,
        };
    }
    onStage("done");

    onStage("processingPlayers");

    await nextFrame();
    let resultV3;
    try {
        resultV3 = await actions.preflightProviderPlayers({
            campaignId,
            players: normalizedPlayers 
        });
    } catch (e) {
        console.error("V3 ERROR", e);
        onStage("done");
        return {
            campaignId,
            okPlayers: [],
            failedPlayers: normalizedPlayers
        };
    }
    const responses = resultV3.responses || [];
    const okIds = responses.map(r => r.player_id);

    const okPlayers = normalizedPlayers.filter(p =>
        okIds.includes(p.playerId)
    );

    const failedPlayers = normalizedPlayers.filter(p =>
        !okIds.includes(p.playerId)
    );

    return {
        campaignId,
        okPlayers,
        failedPlayers
    };

}
export function genBonusIdV2(prefix = "", len = 12) {
    const pre = String(prefix || "");
    const sep = pre && !pre.endsWith("_") ? "_" : "";
    let s = "";
    while (s.length < len) s += Math.random().toString(36).slice(2);
    return `${pre}${sep}${s.slice(0, len).toUpperCase()}`;
}